import React, { useEffect, useMemo } from 'react';
import { SegmentedButtons } from '@scale/scaleui';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';

interface SegmentedButtonsBuilderProps {
  name: string;
  existingValue?: string;
  updateProperty: (arg: string) => void;
  required?: boolean;
  hint?: string;
  choices?: Array<string>;
}

const SegmentedButtonsBuilder: React.FC<SegmentedButtonsBuilderProps> = ({
  name,
  existingValue,
  updateProperty,
  required,
  hint,
  choices,
}) => {
  const buttonsOptions = useMemo(
    () => (choices ?? []).map(choice => ({ id: choice, label: choice })),
    [choices],
  );

  // default to first choice if no existing value
  useEffect(() => {
    if (!existingValue && choices?.length) {
      updateProperty(choices[0]);
    }
  }, [existingValue, choices, updateProperty]);

  return (
    <div className="flex flex-col items-start">
      <label className="my-1 text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex gap-4">
        <SegmentedButtons
          buttons={buttonsOptions}
          onSelect={value => updateProperty(value as string)}
          selected={existingValue ?? choices?.[0] ?? ''}
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default SegmentedButtonsBuilder;
